import {UserAdsError} from './UserAdsError.js'

export class GetUserAdsError extends UserAdsError {
  #message
  static create({message}) {
    return new GetUserAdsError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  toJSON() {
    return {message: this.#message}
  }
}
